var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", { staticClass: "text-primary" }, [
      _vm._v("Este paso será agregado después de ti")
    ]),
    _c("form", { attrs: { "data-vv-scope": "flow-part-1" } }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c(
              "vs-select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo de paso",
                  name: "stepType",
                  danger: _vm.errors.has("flow-part-1.stepType"),
                  "danger-text": _vm.errors.first("flow-part-1.stepType")
                },
                model: {
                  value: _vm.newStep.stepType,
                  callback: function($$v) {
                    _vm.$set(_vm.newStep, "stepType", $$v)
                  },
                  expression: "newStep.stepType"
                }
              },
              [
                _c("vs-select-item", {
                  attrs: { value: _vm.stepTypes.USER, text: "Usuario" }
                }),
                _c("vs-select-item", {
                  attrs: { value: _vm.stepTypes.GROUP, text: "Grupo" }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c(
              "vs-select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo de rol",
                  name: "rolType",
                  danger: _vm.errors.has("flow-part-1.rolType"),
                  "danger-text": _vm.errors.first("flow-part-1.rolType")
                },
                model: {
                  value: _vm.newStep.rolType,
                  callback: function($$v) {
                    _vm.$set(_vm.newStep, "rolType", $$v)
                  },
                  expression: "newStep.rolType"
                }
              },
              [
                _c("vs-select-item", {
                  attrs: { value: _vm.rolTypes.APPROVER, text: "Aprobador" }
                }),
                _c("vs-select-item", {
                  attrs: { value: _vm.rolTypes.REVIEWER, text: "Revisor" }
                }),
                !_vm.isSigner && !_vm.hasSignaturePosition
                  ? _c("vs-select-item", {
                      attrs: { value: _vm.rolTypes.SIGNER, text: "Firmante" }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-12 mt-4" }, [
          _vm.newStep.stepType === _vm.stepTypes.USER
            ? _c(
                "div",
                [
                  _c("list-user", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: _vm.newStep.stepType === _vm.stepTypes.USER
                        },
                        expression:
                          "{ required: newStep.stepType === stepTypes.USER }"
                      }
                    ],
                    ref: "userStep",
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "",
                      label: "Usuario",
                      name: "userStep",
                      danger: _vm.errors.has("flow-part-1.userStep"),
                      "danger-text": _vm.errors.first("flow-part-1.userStep")
                    },
                    model: {
                      value: _vm.newStep.responsable,
                      callback: function($$v) {
                        _vm.$set(_vm.newStep, "responsable", $$v)
                      },
                      expression: "newStep.responsable"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.newStep.stepType === _vm.stepTypes.GROUP
            ? _c(
                "div",
                [
                  _c("list-groups", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: _vm.newStep.stepType === _vm.stepTypes.GROUP
                        },
                        expression:
                          "{ required: newStep.stepType === stepTypes.GROUP }"
                      }
                    ],
                    ref: "groupStep",
                    staticClass: "w-50",
                    attrs: {
                      autocomplete: "",
                      label: "Grupo",
                      name: "groupStep",
                      typeList: _vm.newStep.stepType,
                      danger: _vm.errors.has("flow-part-1.groupStep"),
                      "danger-text": _vm.errors.first("flow-part-1.groupStep")
                    },
                    model: {
                      value: _vm.newStep.responsable,
                      callback: function($$v) {
                        _vm.$set(_vm.newStep, "responsable", $$v)
                      },
                      expression: "newStep.responsable"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "mt-4 text-right" },
      [
        _c(
          "b-button",
          {
            attrs: { "data-cy": "cancel-add-step", variant: "secondary" },
            on: {
              click: function($event) {
                return _vm.cancelAction()
              }
            }
          },
          [_vm._v(" Cancelar ")]
        ),
        _c(
          "b-button",
          {
            staticClass: "ml-2",
            attrs: { "data-cy": "add-step-process", variant: "primary" },
            on: {
              click: function($event) {
                return _vm.handleOk()
              }
            }
          },
          [_vm._v(" Agregar paso ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }